import { Box, Center, Flex, Grid } from '@chakra-ui/react';
import { CheckIcon } from '@heroicons/react/24/outline';
import { Text } from '@main/complykit/components/text';

export type SetupStep = {
  title: string;
  description: string;
};

type SetupStepsProps = {
  steps: SetupStep[];
  completedCount: number;
};

export const SetupSteps = ({ steps, completedCount }: SetupStepsProps) => (
  <Grid
    templateColumns={{ base: '1fr', md: `repeat(${steps.length}, minmax(0, 1fr))` }}
    gap={{ base: 4, md: 0 }}
  >
    {steps.map((step, index) => {
      const isActive = index <= completedCount;
      const isComplete = index < completedCount;
      const isLast = index === steps.length - 1;
      return (
        <Box key={step.title} position="relative">
          {!isLast && (
            <Box
              display={{ base: 'none', md: 'block' }}
              position="absolute"
              top={3}
              left="50%"
              right="-50%"
              h="1px"
              bg={isActive ? 'blue.500' : 'gray.300'}
            />
          )}
          <Flex direction="column" alignItems="center" textAlign="center" gap={2}>
            <Center
              w={6}
              h={6}
              flexShrink={0}
              borderRadius="full"
              fontSize="xs"
              fontWeight="semibold"
              bg={isActive ? 'blue.500' : 'white'}
              color={isActive ? 'white' : 'gray.500'}
              borderWidth={isActive ? 0 : '1px'}
              borderColor="gray.300"
              position="relative"
              zIndex={1}
            >
              {isComplete ? <CheckIcon width={14} height={14} /> : index + 1}
            </Center>
            <Box px={{ md: 2 }}>
              <Text size="sm" weight="medium">
                {step.title}
              </Text>
              <Text size="xs" color="muted">
                {step.description}
              </Text>
            </Box>
          </Flex>
        </Box>
      );
    })}
  </Grid>
);
